import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiDeviationChecklistDetailsTableWrapperDialogComponent } from '@fi-shared/checklist/fi-checklist2-report/components/deviations-report/deviation-checklist-details-table-wrapper-dialog/deviation-checklist-details-table-wrapper-dialog.component';
import { FiDeviationChecklistDetailsTable } from '@fi-shared/checklist/fi-checklist2-report/components/deviations-report/deviation-checklist-details-table-wrapper/deviation-checklist-details-table/deviation-checklist-details-table.component';
import { FiDeviationChecklistDetailsTableWrapperComponent } from '@fi-shared/checklist/fi-checklist2-report/components/deviations-report/deviation-checklist-details-table-wrapper/deviation-checklist-details-table-wrapper.component';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatCardModule } from '@angular/material/card';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { FiTaskSharedModule } from '@fi-shared/fi-task-shared/fi-task-shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { FiChecklist2CheckpointSectionEditModule } from '@fi-shared/checklist/fi-checklist2-edit/checkpoints-section-edit/checkpoint-section-edit.module';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { FiIconTooltipButtonModule } from '@fi-shared/fi-icon-tooltip-button/fi-icon-tooltip-button.module';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { FiDeviationWidgetComponent } from '@fi-shared/checklist/fi-checklist2-report/components/deviations-report/deviation-widget/deviation-widget.component';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FiDeviationCheckpointsChartComponent } from '@fi-shared/checklist/fi-checklist2-report/components/deviations-report/deviation-checkpoints-chart/deviation-checkpoints-chart.component';
import { FiDeviationsReportComponent } from '@fi-shared/checklist/fi-checklist2-report/components/deviations-report/deviations-report.component';
import { FiDeviationCheckpointsTableWrapperComponent } from '@fi-shared/checklist/fi-checklist2-report/components/deviations-report/deviation-checkpoints-table-wrapper/deviation-checkpoints-table-wrapper.component';
import { FiDeviationCheckpointsTableComponent } from '@fi-shared/checklist/fi-checklist2-report/components/deviations-report/deviation-checkpoints-table/deviation-checkpoints-table.component';
import { FiDeviationTasksDialogComponent } from '../../components/deviations-report/deviation-tasks-dialog/deviation-tasks-dialog.component';
import { FiDeviationTaskListItemComponent } from '../../components/deviations-report/deviation-tasks-dialog/deviation-task-list-item/deviation-task-list-item.component';
import { FiDeviationChecklistDetailsComponent } from '@fi-shared/checklist/fi-checklist2-report/components/deviations-report/deviation-checklist-details/deviation-checklist-details.component';
import { FiDeviationOneTimeTaskEditorDialogComponent } from '../../components/deviations-report/deviation-one-time-task-editor-dialog/deviation-one-time-task-editor-dialog.component';
import { FiChecklist2ReportSharedModule } from '@fi-shared/checklist/fi-checklist2-report/components/shared/checklist-report-shared.module';
import { FiChecklist2ReportColumnDefsModule } from '@fi-shared/checklist/fi-checklist2-report/fi-checklist2-report-column-defs/fi-checklist2-report-column-defs.module';
import { FiChecklist2ListColumnDefsModule } from '@fi-shared/checklist/fi-checklist2-list-column-defs/fi-checklist2-list-column-defs.module';
import { FiAutomatedActionListItemModule } from '@fi-shared/automated-action-list-item/action-list-item.module';
import { TaskEditTaskAssigneeModule } from '@fi-shared/fi-task-shared/task-edit-task-assignee/task-edit-task-assignee.module';
import { FiReportWidgetModule } from '@fi-shared/fi-report-widget/fi-report-widget.module';
import { FiReportPieChartModule } from '@fi-shared/fi-report-pie-chart/fi-report-pie-chart.module';
import { FiTaskV2EditModule } from '@fi-app/task-v2/fi-task-v2-edit/fi-task-v2-edit.module';
import { FiSimpleContenteditableModule } from '@fi-shared/fi-simple-contenteditable/fi-simple-contenteditable.module';
import { MatDividerModule } from '@angular/material/divider';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { FiNameInputModule } from '@fi-shared/fi-name-input/fi-name-input.module';
import { FiNameDescriptionInputModule } from '@fi-shared/name-description-input/name-description-input.module';
@NgModule({
    imports: [
        CommonModule,
        FiLoadingModule,
        FiPageHeaderModule,
        FiAppTextSharedModule,
        FiChecklist2ReportSharedModule,
        MatCardModule,
        FiWrapperTableModule,
        FiAttachmentsModule,
        FiProfileIconModule,
        MatIconModule,
        MatInputModule,
        FormsModule,
        FiTaskSharedModule,
        MatButtonModule,
        MatTabsModule,
        MatMenuModule,
        FiChecklist2CheckpointSectionEditModule,
        InfoIconModule,
        FiIconTooltipButtonModule,
        FiFormatDateModule,
        FiChecklist2ReportColumnDefsModule,
        CdkDragHandle,
        FiChecklist2ListColumnDefsModule,
        FiAutomatedActionListItemModule,
        TaskEditTaskAssigneeModule,
        FiReportWidgetModule,
        FiReportPieChartModule,
        FiTaskV2EditModule,
        FiSimpleContenteditableModule,
        MatDividerModule,
        FiValidatingFormModule,
        FiNameInputModule,
        FiNameDescriptionInputModule,
    ],
    declarations: [
        FiDeviationChecklistDetailsTableWrapperDialogComponent,
        FiDeviationChecklistDetailsTableWrapperComponent,
        FiDeviationChecklistDetailsTable,
        FiDeviationChecklistDetailsComponent,
        FiDeviationWidgetComponent,
        FiDeviationCheckpointsChartComponent,
        FiDeviationsReportComponent,
        FiDeviationCheckpointsTableWrapperComponent,
        FiDeviationCheckpointsTableComponent,
        FiDeviationTasksDialogComponent,
        FiDeviationTaskListItemComponent,
        FiDeviationOneTimeTaskEditorDialogComponent,
    ],
    exports: [
        FiDeviationChecklistDetailsComponent,
        FiDeviationsReportComponent,
        FiDeviationCheckpointsTableWrapperComponent,
        FiDeviationWidgetComponent,
    ],
})
export class FiChecklist2ReportDeviationsModule {}
